<template>
  <div>
    <template v-for="f in Object.keys(formFields)" :key="f">
      <!-- GROUPED FIELDS -->
      <div v-if="formFields[f].type === 'group'" uk-accordion class="custom-fields-panel">
        <div>
          <!-- GROUP HEADER -->
          <span
            class="uk-accordion-title uk-text-bolder uk-text-large uk-text-emphasis"
            @click="customFieldsOpen = !customFieldsOpen"
          >
            <img
              :src="`/icons/black/icon-black-outline-node.svg`"
              class="custom-fields-panel-knob uk-margin-small-right"
              :style="{
                transform: customFieldsOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
              }"
            />
            {{ formFields[f].header }}
          </span>

          <div class="uk-accordion-content uk-background-muted uk-padding-small uk-border-rounded">
            <!-- NESTED FIELDS -->
            <FormFields
              :formFields="formFields[f].fields"
              :formValues="form"
              :validator="validator"
              @fieldFocusOut="form = { ...form, ...$event }"
            />
          </div>
        </div>
      </div>

      <!-- INDIVIDUAL FIELDS -->
      <form-group
        :key="f"
        v-else-if="
          !formFields[f].uiModeHidden ||
          (formFields[f].uiModeHidden && uiMode !== formFields[f].uiModeHidden)
        "
        class="uk-margin uk-width-1-1"
        :class="{ error: validator.form[f].$error }"
        :validator="validator.form[f]"
      >
        <!-- HEADER -->
        <span class="uk-text-bolder uk-text-large uk-text-emphasis">
          {{ formFields[f].header }}
          <span
            v-if="validator.form[f].$params.required"
            :style="{
              color: !validator.form[f].required ? 'red' : undefined,
            }"
            >*</span
          >
        </span>

        <span class="uk-inline full-width">
          <!-- ICON -->
          <span
            v-if="formFields[f].icon"
            class="uk-form-icon"
            :uk-icon="`icon: ${formFields[f].icon}`"
          ></span>

          <!-- TEXT AREA -->
          <textarea
            v-if="formFields[f].type === 'textarea'"
            class="uk-textarea"
            v-model="form[f]"
            :placeholder="formFields[f].placeholder"
            rows="10"
            required
            @focusout="$emit('fieldFocusOut', { [f]: form[f] })"
          ></textarea>

          <!-- CUSTOM -->
          <div v-else-if="formFields[f].type === 'custom'" class="uk-flex uk-flex-column">
            <div class="uk-flex">
              <input
                class="uk-input uk-width-1-3 uk-margin-right"
                type="text"
                :placeholder="formFields[f].placeholder.label"
                v-model="form[f].label"
                maxlength="25"
                @input="validator.form[f].$touch()"
                @focusout="$emit('fieldFocusOut', { [f]: form[f] })"
              />
              <input
                class="uk-input"
                type="text"
                :placeholder="formFields[f].placeholder.value"
                v-model="form[f].value"
                @input="validator.form[f].$touch()"
                @focusout="$emit('fieldFocusOut', { [f]: form[f] })"
              />
            </div>
          </div>

          <!-- TEXT INPUT -->
          <input
            v-else
            class="uk-input"
            :type="formFields[f].type"
            :placeholder="formFields[f].placeholder"
            v-model="form[f]"
            required
            @input="validator.form[f].$touch()"
            @focusout="$emit('fieldFocusOut', { [f]: form[f] })"
          />
        </span>
      </form-group>
    </template>
  </div>
</template>

<script>
export default {
  name: 'FormFields',

  props: {
    formFields: Object,
    formValues: Object,
    validator: Object,
  },

  data() {
    return {
      form: {},
      customFieldsOpen: false,
    };
  },

  watch: {
    formValues: {
      immediate: true,
      deep: true,
      handler(val) {
        if (!val) return;

        this.form = {
          ...this.formValues,
        };
      },
    },
  },
};
</script>

<style lang="sass">
.error
  input
    border-color: red

.custom-fields-panel
  .uk-accordion-title::before
    content: unset !important
  &-knob
    transition: transform .3s ease
</style>
